import { render, staticRenderFns } from "./OwnerResult.vue?vue&type=template&id=ebd80d2c&scoped=true&"
import script from "./OwnerResult.vue?vue&type=script&lang=js&"
export * from "./OwnerResult.vue?vue&type=script&lang=js&"
import style0 from "./OwnerResult.vue?vue&type=style&index=0&id=ebd80d2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd80d2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VIcon,VLayout,VSpacer})
